import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import CopilotPanel from './CopilotPanel';

type CopilotContextValue = {
  open: boolean;
  openCopilot: (seedQuestion?: string) => void;
  closeCopilot: () => void;
};

const CopilotContext = createContext<CopilotContextValue>({
  open: false,
  openCopilot: () => undefined,
  closeCopilot: () => undefined,
});

export const useCopilot = () => useContext(CopilotContext);

export function CopilotProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const [seed, setSeed] = useState<string | null>(null);

  const openCopilot = useCallback((seedQuestion?: string) => {
    setSeed(seedQuestion || null);
    setOpen(true);
  }, []);

  const closeCopilot = useCallback(() => setOpen(false), []);

  const value = useMemo(() => ({ open, openCopilot, closeCopilot }), [open, openCopilot, closeCopilot]);

  return (
    <CopilotContext.Provider value={value}>
      {children}
      <CopilotPanel open={open} seedQuestion={seed} onClose={closeCopilot} onSeedConsumed={() => setSeed(null)} />
    </CopilotContext.Provider>
  );
}
